<!-- 我的简历 -->
<template>
  <div class="resume">
    <!-- 导航栏 -->
    <van-nav-bar
      :title="type==undefined?'我的简历':`${userInfo.name}的简历`"
      fixed
      placeholder
      z-index="100"
      @click-left="onClickLeft"
    >
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>

    <div class="resume-box">
      <!-- 个人简历-->
      <div class="resume-user" @click="type==0?'':navGo()">
        <div class="user-info">
          <span class="user-name">{{userInfo.name}}</span>
          <div class="info-item">
            <span>{{age===''?'暂未填写':`${age}岁`}}</span>
            <span v-if="userInfo.education_name!=''">{{userInfo.education_name}}</span>
            <span v-if="userInfo.soldier_type_name!=''">{{userInfo.soldier_type_name}}</span>
          </div>
        </div>
        <img
          :src="type==0?userInfo.avatar:userInfo.avatar==''?require('@/assets/img/home/timg.jpg'):userInfo.avatar"
          class="user-img"
        />
      </div>
      <!-- 加密 -->
      <!-- <div class="resume-encrypt" v-if="type==undefined">
        <div class="encrypt-left">
          <span>加密当前简历</span>
          <img src="@/assets/img/user/tishi.png" class="left-tips" />
        </div>

        <van-radio-group v-model="radio" class="encrypt-right">
          <van-radio name="1">
            <span :class="radio==1?'checked':''">是</span>
            <template #icon="props">
              <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
            </template>
          </van-radio>
          <van-radio name="2">
            <span :class="radio==2?'checked':''">否</span>
            <template #icon="props">
              <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
            </template>
          </van-radio>
        </van-radio-group>
      </div>-->
      <!--  求职意向 -->
      <div class="resume-intention">
        <span>求职意向</span>
        <span style="font-size:0.24rem" v-if="type!=undefined">{{userInfo.apply_status}}</span>
        <img src="@/assets/img/user/add.png" class="add-img" v-else @click="navDetails(0)" />
      </div>
      <!-- 职位列表 -->
      <div
        class="resume-list"
        v-for="(item, index) in positonList"
        :key="index"
        @click="type==0?'':goDetails(item.resume_intent_id,0)"
      >
        <div class="resume-request">
          <span>{{item.job_cn}} {{item.wage_cn}}</span>
          <span>{{item.district_cn}}</span>
        </div>
        <img src="@/assets/img/position/into.png" class="back" v-if="type==undefined" />
      </div>
      <!-- 工作经历 -->
      <div class="resume-intention" @click="type==0?'':navDetails(1)">
        <span>工作经历</span>
        <img src="@/assets/img/user/add.png" class="add-img" v-if="type==undefined" />
      </div>
      <!-- 工作经历列表 -->
      <div>
        <div
          class="resume-express"
          v-for="(item, index) in worklist"
          :key="index"
          @click="type==0?'':goDetails(item.resume_work_id,1)"
        >
          <div class="express-top">
            <p>{{item.company}}</p>
            <div class="top-time">
              <span>{{item.start_time}} ~ {{item.todate==0?item.end_time:'至今'}}</span>
              <img src="@/assets/img/position/into.png" class="back" v-if="type==undefined" />
            </div>
          </div>
          <p class="express-position">{{item.jobs}}</p>
          <p class="express-content">{{item.description}}</p>
        </div>
      </div>
      <!-- 教育经历 -->
      <div class="resume-intention" @click="type==0?'':navDetails(2)">
        <span>教育经历</span>
        <img src="@/assets/img/user/add.png" class="add-img" v-if="type==undefined" />
      </div>
      <!-- 教育经历列表 -->
      <div>
        <div
          class="resume-express"
          v-for="(item, idx) in edctionList"
          :key="idx"
          @click="type==0?'':goDetails(item.resume_education_id,2)"
        >
          <div class="express-top">
            <p>{{item.school}}</p>
            <div class="top-time">
              <span>{{item.start_time}} ~ {{item.todate==0?item.end_time:'至今'}}</span>
              <img src="@/assets/img/position/into.png" class="back" v-if="type==undefined" />
            </div>
          </div>
          <div class="express-position">
            {{item.education_name}}
            <span>·</span>
            {{item.speciality}}
          </div>
        </div>
      </div>
      <!--  个人优势 -->
      <div class="resume-intention" @click="type==0?'':navDetails(3)">
        <span>个人优势</span>
        <img src="@/assets/img/user/edit.png" class="add-img" v-if="type==undefined" />
      </div>
      <div class="resume-advantage">{{type==0?userInfo.description:userInfo.description}}</div>
    </div>
    <!-- 按钮 -->
    <div class="btns" v-if="status!=0">
      <div class="boss-btn">
        <div class="boss-tel" @click="telPhone">
          <img src="@/assets/img/home/tel.png" class="back" />
          <span>电话</span>
        </div>
        <button class="not-btns" @click="status==3?'':notFit()" v-show="status==1||status==3">不合适</button>
        <button
          :class="{'not-btns':interview_status==2||interview_status==3||interview_status==4}"
          @click="status==1||status==4||interview_status==1?interview(status):''"
          v-show="status!=3"
        >{{status==1||status==4?'邀面试':interview_status==2?'面试通过':interview_status==1?'取消面试':interview_status==4?'求职者已拒绝':'不合适'}}</button>
      </div>
    </div>
    <!-- 面试时间弹窗 -->
    <van-popup v-model="show" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="选择面试时间"
        :min-date="minDate"
        :max-date="maxDate"
        :filter="filter"
        @confirm="confirm"
        @cancel="show=false"
      />
    </van-popup>
  </div>
</template>
<script>
import { Toast, Dialog } from "vant";
import {
  queryWorkList,
  queryEductionList,
  queryPositionList,
  queryPersonalInfo,
  queryPreson,
  applyResumeDetail,
  InvitationBtn,
  upLoad,
  cancel,
  refuseInterview
} from "@/api/apiData";
import getFormat from "@/until/getFormatDate";
import { dataURLtoFile, getImgToBase64 } from "@/until/upLoad";
export default {
  components: {},
  inject: ["Token"],
  data() {
    return {
      userInfo: "",
      radio: "1", //性别选择
      activeIcon: require("@/assets/img/user/select.png"),
      inactiveIcon: require("@/assets/img/user/unselect.png"),
      type: "", //入口  0牛人推荐  1 待处理
      minDate: "",
      maxDate: "",
      userInfo: "",
      currentDate: new Date(),
      show: false,
      age: "",
      worklist: [], //工作经历列表
      positonList: [], //求职意向列表
      edctionList: [], //教育经历列表
      status: 0, //1未处理 2邀请面试 3不合适
      id: "", //面试简历申请id
      interview_status: 0
    };
  },
  computed: {},
  methods: {
    onClickLeft() {
      if (this.$route.query.resume) {
        this.$router.replace({
          name: "Profile"
        });
      } else {
        this.$router.back();
      }
    },
    // 个人信息修改
    navGo() {
      // 个人信息编辑页
      this.$router.push({
        name: "Edit"
      });
    },
    // 邀请面试
    interview(val) {
      const that = this;
      if (val == 1 || val == 4) {
        // 选择面试时间
        that.show = true;
      } else {
        // 取消面试
        Dialog.confirm({
          title: "面试取消",
          message: "你已经邀请过了该求职者，确定要取消面试邀约吗？"
        })
          .then(() => {
            cancel({ job_apply_id: that.id }).then(res => {
              //(res);
              if (res.code == 1) {
                Toast.success({
                  message: "面试取消成功",
                  forbidClick: true
                });
                setTimeout(() => {
                  that.$router.back();
                }, 2000);
              } else {
                Toast(res.msg);
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    // 求职列表详情跳转
    goDetails(id, val) {
      var that = this;
      switch (val) {
        case 0: //求职详情
          that.$router.push({
            name: "Experience",
            params: {
              title: 3,
              id: id,
              disabled: false
            }
          });
          break;
        case 1: //工作详情
          that.$router.push({
            name: "Experience",
            params: {
              title: 5,
              id: id
            }
          });
          break;
        case 2: //教育详情
          that.$router.push({
            name: "Experience",
            params: {
              title: 1,
              id: id
            }
          });
          break;
      }
    },

    // 获取工作 教育 求职意向列表
    getList() {
      var that = this;
      // 求职意向列表
      queryPositionList().then(rest => {
        if (rest.code == 1) {
          that.positonList = rest.data;
        } else {
          Toast(rest.msg);
        }
      });
      // 工作列表
      queryWorkList().then(res => {
        if (res.code == 1) {
          that.worklist = res.data;
        } else {
          Toast(res.msg);
        }
      });
      // 教育列表
      queryEductionList().then(res => {
        if (res.code == 1) {
          that.edctionList = res.data;
        } else {
          Toast(res.msg);
        }
      });
      // 个人优势
      // queryPersonalInfo().then(res => {
      //   //(res);
      //   if (res.code == 1) {
      //     that.userInfo = res.data;
      //   }
      // });
      // 简历信息
      queryPreson().then(res => {
        //(res);
        if (res.code == 1) {
          var userInfo = res.data;
          that.userInfo = userInfo;
          var time = new Date();
          var Y = time.getFullYear();
          var arr = userInfo.birthday.split("-");
          that.age = Y - Number(arr[0]) + 1;
        }
      });
    },
    // 公司端入口
    getDetails(id) {
      var that = this;
      var obj = {
        job_apply_id: id
      };
      applyResumeDetail(obj).then(res => {
        if (res.code == 1) {
          that.positonList = res.data.intent_list;
          that.edctionList = res.data.education_list;
          that.worklist = res.data.work_list;
          that.userInfo = res.data.userinfo;
          that.age =new Date().getFullYear()-Number(res.data.userinfo.birthday.split("-")[0])+1;
        }
      });
    },
    // 分钟过滤
    filter(type, options) {
      if (type === "minute") {
        return options.filter(option => option % 5 === 0);
      }
      return options;
    },
    // 选定面试时间
    confirm(val) {
      // //(val);
      var that = this;
      that.show = false;
      let date = getFormat(val, "yy-mm-ss-hh");
      //(date);
      let obj = {
        job_apply_id: that.id,
        date: date
      };
      InvitationBtn(obj).then(res => {
        //(res);
        if (res.code == 1) {
          Toast.success({
            message: "邀请已发送",
            forbidClick: true
          });
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        } else {
          Toast(res.msg);
        }
      });
    },
    // 不合适
    notFit() {
      // //(11);
      refuseInterview({ job_apply_id: this.id }).then(res => {
        Toast.success({
          message: "消息已发送",
          forbidClick: true,
          duration: 2000
        });
        setTimeout(() => {
          this.$router.back();
        }, 2000);
      });
    },
    //拨打电话
    telPhone() {
      window.location.href = `tel:${this.userInfo.mobile}`;
    },
    // 路由跳转
    navDetails(val) {
      if (val == 0) {
        // 添加求职意向
        this.$router.push({
          name: "JobSearch"
        });
      } else if (val == 1) {
        // 添加工作经历
        this.$router.push({
          name: "Experience",
          params: {
            title: 0
          }
        });
      } else if (val == 2) {
        // 添加教育经历
        this.$router.push({
          name: "Experience",
          params: {
            title: 6
          }
        });
      } else {
        this.$router.push({
          name: "Experience",
          params: {
            title: 2
          }
        });
      }
    }
  },
  created() {
    // 判断入口
    this.type = this.$route.query.type;
    // 获取当前时间
    var Y = new Date().getFullYear();
    this.minDate = new Date(Y, 0, 1);
    this.maxDate = new Date(Y, 11, 1);
  },
  mounted() {
    if (this.type == 0) {
      this.getDetails(this.$route.query.id);
      this.status = this.$route.query.status;
      this.id = this.$route.query.id;
      this.interview_status = this.$route.query.interview_status;
    } else {
      this.Token();
      this.getList();
    }
  }
};
</script>
<style lang='less' scoped>
.resume-box {
  padding: 0 0.32rem;
  //   个人信息
  .resume-user {
    padding: 0.4rem 0;
    display: flex;
    justify-content: space-between;
    .user-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .user-name {
        font-size: 0.48rem;
        font-weight: bold;
        line-height: 0.67rem;
        color: #333333;
        text-align: left;
      }
      .info-item {
        display: flex;
        align-items: center;
        margin-top: 0.1rem;
        span {
          display: flex;
          align-items: center;
          font-size: 0.26rem;
          font-weight: 400;
          color: #4d4d4d;
        }
        span::after {
          content: "";
          width: 0.02rem;
          height: 0.26rem;
          display: block;
          background: #4d4d4d;
          margin: 0 0.2rem;
        }
        span:last-child::after {
          display: none;
        }
      }
    }
    .user-img {
      width: 1.4rem;
      height: 1.4rem;
      font-size: 0.2rem;
      border-radius: 50%;
    }
  }
  // 加密
  .resume-encrypt {
    // margin-top: 0.2rem;
    padding: 0.23rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .encrypt-left,
    .encrypt-right {
      flex: 1;
      display: flex;
      align-items: center;
      padding: 0.23rem 0;
      span {
        font-size: 0.32rem;
        font-weight: bold;
        line-height: 0.45rem;
        color: rgba(51, 51, 51, 1);
      }
      .left-tips {
        width: 0.32rem;
        height: 0.32rem;
        border-radius: 50%;
      }
    }

    /deep/.van-radio-group {
      display: flex;

      .van-radio {
        flex: 1;
        display: flex;
        align-items: center;
        .img-icon {
          width: 0.4rem;
          height: 0.4rem;
        }
        .van-radio__label {
          font-size: 0.3rem;
          line-height: 0.42rem;
          color: #cccccc;
        }
        .checked {
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
  }
  //   求职意向
  .resume-intention {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.23rem 0;
    margin-top: 0.2rem;
    span {
      font-size: 0.32rem;
      font-weight: bold;
      line-height: 0.45rem;
      color: rgba(51, 51, 51, 1);
    }
    .add-img {
      width: 0.3rem;
      height: 0.3rem;
    }
  }
  //   职位列表
  .resume-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2rem 0;
    .resume-request {
      span {
        display: block;
        font-size: 0.28rem;
        font-weight: bold;
        line-height: 0.4rem;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 0.1rem;
      }
      span:last-child {
        font-size: 0.26rem;
        font-weight: 400;
        line-height: 0.37rem;
        color: rgba(102, 102, 102, 1);
        text-align: left;
      }
    }
  }
  // 工作经历列表
  .resume-express {
    padding: 0.2rem 0;
    font-size: 0.26rem;
    .express-top {
      display: flex;
      p {
        text-align: left;
        flex: 1.2;
        color: #333333;
        font-size: 0.28rem;
        font-weight: bold;
        line-height: 0.4rem;
        color: rgba(51, 51, 51, 1);
      }
      .top-time {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        span {
          display: inline;
          font-size: 0.24rem;
          font-weight: 400;
          line-height: 0.4rem;
          color: rgba(179, 179, 179, 1);
        }
      }
    }
    .express-position {
      display: flex;
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.4rem;
      color: rgba(102, 102, 102, 1);
      text-align: left;
      margin: 0.12rem 0 !important;
      span {
        font-size: 1rem;
      }
    }
    .express-content {
      font-weight: 400;
      line-height: 0.4rem;
      color: rgba(102, 102, 102, 1);
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
  // 个人优势
  .resume-advantage {
    text-align: left;
    font-size: 0.26rem;
    font-weight: 400;
    line-height: 0.4rem;
    color: rgba(102, 102, 102, 1);
    margin-bottom: 1.5rem;
  }
}
.btns {
  .boss-btn {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    padding: 0.26rem 0.32rem;
    background: #fff;
    box-shadow: 0px -1px 0px rgba(0, 0, 0, 0.08);
    .boss-tel {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 0.2rem;
      font-weight: 400;
      line-height: 0.28rem;
      color: rgba(128, 128, 128, 1);
      flex: 1;
      span {
        margin-top: 0.1rem;
      }
    }
    .not-btns {
      flex: 3;
      background: rgba(247, 247, 247, 1);
      color: rgba(102, 102, 102, 1);
    }
    button {
      flex: 6;
      background: #ff4343;
      box-shadow: 0px -0.01rem 0px rgba(0, 0, 0, 0.08);
      font-weight: 400;
      line-height: 0.4rem;
      color: rgba(255, 255, 255, 1);
      letter-spacing: 0.1rem;
      font-size: 0.28rem;
      border-radius: 0.08rem;
      padding: 0.2rem 0;
      margin-left: 5%;
    }
  }
}
.btns::before {
  content: "";
  display: block;
  height: 1.5rem;
  width: 100%;
}
</style>